import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React from "react";
import { useTranslation } from "react-i18next";

import { AccountContactsPage } from "./account_contacts_page";
import { useAccountContactsPage } from "./use_account_contacts_page";

const initPage = { emailTemplate: null, emailTemplateSchemas: null, loaded: false };

const AccountContactsController = () => {
  const { t } = useTranslation("admin");
  const { loaded, accountContact, errors } = useAccountContactsPage(initPage);
  const WrappedAccountContacts = usePageWrapper(AccountContactsPage);

  return (
    <WrappedAccountContacts
      loading={!loaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message={t("accountContacts.error")}
          buttonMessage={t("accountContacts.button")}
          buttonUrl="/admin/account_contacts"
        />
      }
      accountContact={accountContact}
    />
  );
};

export default AccountContactsController;
